import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { UserSearchDialogComponent } from './user-search-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimeAgoPipeModule } from '@go-modules/pipes/timeago/timeago.pipe.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		A11yModule,
		MatTooltipModule,
		TimeAgoPipeModule,
		GoDialogContentDirective
	],
	declarations: [
		UserSearchDialogComponent
	],
	exports: [
		UserSearchDialogComponent
	]
})
export class UserSearchDialogModule {}
